const data = [
  {
    id: 'recAGJfiU4CeaV0HL',
    order: 3,
    title: 'Full Stack Web Developer',
    dates: 'May 2020 - Present',
    duties: [
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae cum nesciunt facilis sequi voluptatem eos!',
      'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Culpa repellat nam id assumenda consequatur blanditiis ducimus soluta labore! In, dolorem.',
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Temporibus, dolor. Esse laudantium iusto similique deserunt, repellat, debitis, consequuntur repudiandae obcaecati est voluptatem saepe vero neque nemo nesciunt ea explicabo et cum. Veniam odit, provident nisi animi accusamus architecto vero! Vero.',
    ],
    company: 'XYZ Company',
  },
  {
    id: 'recIL6mJNfWObonls',
    order: 2,
    title: 'App Developer',
    dates: 'May 2019 - May 2020',
    duties: [
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem quaerat quisquam, excepturi autem saepe velit animi libero ducimus voluptatum laboriosam?',
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto magnam delectus dicta consectetur hic quaerat nobis vel quia dolorem velit?',
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Velit reiciendis itaque consectetur expedita asperiores voluptatum qui!',
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Praesentium eius neque, obcaecati quidem unde dolor eligendi, fugiat eum perspiciatis explicabo velit illum deserunt ex perferendis?',
    ],
    company: 'ABC Company',
  },
  {
    id: 'rec61x18GVY99hQq5',
    order: 1,
    title: 'Intern',
    dates: 'December 2018 - May 2019',
    duties: [
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia non voluptas saepe unde blanditiis iure?',
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit consequuntur modi minus facere rem laborum ducimus magnam hic mollitia qui!',
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Facere et similique impedit, sunt harum voluptatum, quo quae optio soluta nemo exercitationem aperiam! Enim est exercitationem facilis aut facere iure quibusdam?',
    ],
    company: 'PQR Company',
  },
]
export default data